import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import NumberField from 'modules/core/components/NumberField'

import { NonWeightableTooltip } from 'modules/performance_process/components/score_configuration_weights/NonWeightableTooltip'

export const WeightInput: React.FC<{
  value: number | null | undefined
  weightable: boolean
  getRef?: (ref: HTMLInputElement | null | undefined) => unknown
  onChange: (value: number | null) => void
}> = ({ value, weightable, getRef, onChange }) => {
  const Wrapper = weightable ? React.Fragment : NonWeightableTooltip
  return (
    <Box width="s96">
      <Wrapper>
        <NumberField
          indicator="%"
          min={0}
          max={100}
          value={value}
          onChange={onChange}
          readonly={!weightable}
          maxDecimals={1}
          getRef={getRef}
        />
      </Wrapper>
    </Box>
  )
}
